<template>
  <b-modal :active.sync="localStartEbookModal" :width="640" scroll="keep">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Start Ebook
        </p>

        <a class="card-header-icon" @click="closeModal()">
          <span class="icon is-small">
          <i class="mdi mdi-close"></i>
          </span>
        </a>

      </header>
      <single-ebook-card-content/>
      <div class="card-content" v-if="!isSubscribedUser">
        {{ canRreadEbooksSentence }}
        <button class="button is-secondary" @click="goToSubscription" v-if="!canStartReadingEbook">Go to subscription</button>
      </div>
      <footer class="modal-card-foot">
        <button v-bind:class="{ 'is-loading': isLocalLoading }" class="button is-primary" @click="startEbook()" :disabled="isStartEbookButtonDisabled">
          <span>Start Reading!</span>
        </button>
        <button v-if="internalEbook.amazonAffiliateUrl" class="button is-secondary" @click="clickOnAmazonLink()">
          <span>Learn More</span>
        </button>
        <button class="button" @click="closeModal()">
          Cancel
        </button>
      </footer>
      <b-loading :is-full-page="false" :active.sync="isLocalLoading" :can-cancel="false"></b-loading>
    </div>
  </b-modal>
</template>

<script>
import singleEbookCardContent from '@/components/single-ebook-card-content'

export default {
  name: 'startEbookModal',
  data () {
    return {
      localStartEbookModal: false,
      internalEbook: {}
    }
  },
  watch: {
    getEbook (value) {
      this.internalEbook = value
    },
    localStartEbookModal (value) {
      if (!value) {
        this.$store.dispatch('closeStartEbookModal')
      }
    },
    startEbookModal (value) {
      this.localStartEbookModal = value
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('closeStartEbookModal')
    },
    clickOnAmazonLink () {
      this.$store.dispatch('updateEbookOnAmazonLinkClick')
    },
    goToSubscription () {
      this.$store.dispatch('closeStartEbookModal')
      this.$router.push('/subscription')
    },
    startEbook () {
      this.$store.dispatch('startReadDiscoverEbook', {
        ebookId: this.internalEbook.id
      })
    }
  },
  computed: {
    canRreadEbooksSentence () {
      if (!this.isSubscribedUser) {
        if (this.$store.getters.getUserTicketsCount > 0) {
          return `You can still read ${this.$store.getters.getUserTicketsCount} ebooks.`
        }
        return `You can't start a new ebook.`
      }
    },
    canStartReadingEbook () {
      return this.$store.getters.getUserTicketsCount > 0 || this.isSubscribedUser
    },
    getEbook () {
      return this.$store.getters.getEbook
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isLocalLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'startEbookModal' && localLoading.active
    },
    isSubscribedUser () {
      return this.$store.getters.isSubscribedUser
    },
    isStartEbookButtonDisabled () {
      return !this.canStartReadingEbook
    },
    startEbookModal () {
      return this.$store.getters.isStartEbookModal
    }
  },
  components: {
    singleEbookCardContent
  }
}
</script>

<style>

</style>
